import React from 'react';
import { GridSpacing } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from './styles';

export type SpaceProps = {
    className?: string;
    spacing?: GridSpacing;
    variant?: 'height' | 'width';
};

const Space: React.FC<SpaceProps> = ({ className, spacing = 1, variant = 'height', ...rest }: SpaceProps) => {
    const classes = useStyles();
    return <div className={clsx(classes.root, classes[`${variant}-spacing-${spacing}`], className)} {...rest} />;
};

export default Space;
